import React from 'react';
import { Component, ReactNode } from 'react';
import { connect } from 'react-redux';

import { RootState } from '../../slices/rootReducer';
import { push } from 'connected-react-router';
import { Redirect } from 'react-router-dom';
import { cognitoLogout } from '../../services/cognito';
import { userLogout } from '../../slices/auth/login.thunks';

interface StateProps {
  isLoggedIn: boolean;
}

interface DispatchProps {
  push: typeof push;
  userLogout: () => void;
}

type ILoggedInContainerProps = StateProps & DispatchProps;

class Logout extends Component<ILoggedInContainerProps> {
  public async componentDidMount() {
    try {
      await cognitoLogout();
    } catch (e) {
      console.error(e);
    }
    await this.props.userLogout();
    return;
  }

  render(): ReactNode {
    const { isLoggedIn } = this.props;
    if (!isLoggedIn) {
      return <Redirect to="/login" />;
    }
    return null;
  }
}

const mapStateToProps = (state: RootState): StateProps => ({
  isLoggedIn: state.auth.isLoggedIn
});

const mapDispatchToProps: DispatchProps = {
  push,
  userLogout
};

const ConnectedLoggedInContainer = connect(mapStateToProps, mapDispatchToProps)(Logout);

export default ConnectedLoggedInContainer;
